import { useState, useMemo } from "react";
import { useMaterialUIController, setHeaderType } from "context";

import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

export default function HeaderTypeSwitch() {
  const [controller, dispatch] = useMaterialUIController();
  const { headerType } = controller;

  const [open, setOpen] = useState(false);
  const [temp, setTemp] = useState(headerType || "cabecalho1");

  const labels = useMemo(
    () => ({
      cabecalho1: "Moderno (Faixa colorida)",
      cabecalho2: "Tradicional (Título + barra)",
    }),
    []
  );

  const apply = () => {
    setHeaderType(dispatch, temp);
    setOpen(false);
  };

  return (
    <>
      {/* Botão na navbar */}
      <Tooltip title={`Cabeçalho: ${headerType === "cabecalho2" ? "Tradicional" : "Moderno"}`}>
        <IconButton
          size="small"
          color="inherit"
          onClick={() => {
            setTemp(headerType || "cabecalho1");
            setOpen(true);
          }}
          sx={{
            ml: 1,
            width: 36,
            height: 36,
            "&:hover": { bgcolor: "rgba(255,255,255,0.08)" },
          }}
          aria-label="Alterar tipo de cabeçalho"
        >
          <Icon>web_asset</Icon>
        </IconButton>
      </Tooltip>

      {/* Dialog de escolha */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Tipo de cabeçalho</DialogTitle>
        <DialogContent dividers>
          <MDTypography variant="button" color="text">
            Escolha o estilo de cabeçalho a usar nas páginas:
          </MDTypography>

          <RadioGroup
            sx={{ mt: 1.5 }}
            value={temp}
            onChange={(e) => setTemp(e.target.value)}
            name="header-type"
          >
            <FormControlLabel value="cabecalho1" control={<Radio />} label={labels.cabecalho1} />
            <FormControlLabel value="cabecalho2" control={<Radio />} label={labels.cabecalho2} />
          </RadioGroup>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Stack direction="row" spacing={1}>
            <MDButton onClick={() => setOpen(false)} color="secondary" variant="outlined">
              Cancelar
            </MDButton>
            <MDButton onClick={apply} color="info" variant="contained">
              Aplicar
            </MDButton>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
}
